import mapActions from './mapActions';

export default mapActions('default_entity_operations', {
    fetchAll_url: data => `/api/buildings/${data.id}/default_operations`
});
